import React from 'react';
import { Virtuoso } from 'react-virtuoso';

import { lang, rgba, scssVariables as variables, userFullName } from 'src/helpers';
import { MCText, SearchTextField, Spinner, View } from 'src/components/basic';
import { ActivityLabel } from 'src/components/user/LastActivity';
import { remCss, remFontCss } from '../utils';
import ShortInfo from 'src/components/user/ShortInfo';
import LANG_CONST from 'src/helpers/lang/const';
import locationsModel from '../locationsModel';
import managersModel from '../managersModel';

const ManagerItem = ({ item, onManagerItem }) => {
  locationsModel.use();

  return (
    <View
      style={{
        backgroundColor:
          locationsModel.state.manager?.id === item.id
            ? rgba(variables['colors-mc-primary'], 0.1)
            : 'white',
        paddingVertical: remCss(15),
        paddingHorizontal: remCss(20),
        flexDirection: 'row',
        gap: remCss(10),
        alignItems: 'center',
        cursor: 'pointer'
      }}
      onClick={() => onManagerItem(item)}
    >
      <ShortInfo
        user={item}
        fullname={userFullName(item, item.isDoctor)}
        width={80}
        remFontCss={remFontCss}
        onlineState={item.connections > 0 ? 'online' : ''}
        medium={true}
        note={
          <MCText size={18} remFontCss={remFontCss} numberOfLines={1} weight={400} primary>
            <ActivityLabel
              accountState={item.accountState}
              lastActivity={item.lastActivity}
              connections={item.connections}
            />
          </MCText>
        }
      />
    </View>
  );
};

export const Managers = ({ onManagerItem }) => {
  const [searching, setSearching] = React.useState(false);
  managersModel.use();

  const items = managersModel.items();
  const loading = managersModel.refreshing();
  const searchQuery = managersModel.listInput('search');
  const noResults = managersModel.noResults();

  return (
    <View style={{ width: '30%', maxWidth: remCss(400) }}>
      <View style={{ paddingRight: remCss(20) }}>
        <SearchTextField
          template={'2'}
          placeholder={'Search'}
          autoFocus={searching}
          onChange={(v) => {
            setSearching(true);
            managersModel.handleChangeSearch(v);
          }}
          onBlur={() => {
            setTimeout(() => {
              setSearching(false);
            }, 150);
          }}
          value={searchQuery}
        />
      </View>
      <Virtuoso
        data={items}
        style={{ backgroundColor: 'white' }}
        components={{
          Header: () => (
            <View style={{ padding: remCss(10) }}>
              {(noResults || loading) && (
                <>
                  {noResults && !searchQuery && (
                    <div style={{ textAlign: 'center', padding: '1rem' }}>
                      {lang.t(LANG_CONST.text.no_results_yet)}
                    </div>
                  )}
                  {noResults && searchQuery && (
                    <div style={{ textAlign: 'center', padding: '1rem' }}>
                      {lang.t(LANG_CONST.text.nothing_found)}
                    </div>
                  )}
                </>
              )}
            </View>
          ),
          Footer: () => (
            <div style={{ textAlign: 'center', paddingBottom: 20, flex: 1 }}>
              {loading && <Spinner />}
            </div>
          )
        }}
        endReached={() => {
          if (managersModel.hasMore() && !managersModel.refreshing()) managersModel.loadMore();
        }}
        itemContent={(index, item) => (
          <ManagerItem item={item} index={index} onManagerItem={onManagerItem} />
        )}
      />
    </View>
  );
};
